"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var theme_1 = require("../../styles/theme");

var H_1 = require("../primitives/H");

var Img_1 = require("../primitives/Img");

var Layout_1 = require("../primitives/Layout");

var HeroContainer = styled_1["default"](Layout_1.TwoColumn)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  > div {\n    margin: ", "px;\n  }\n"], ["\n  background: ", ";\n  color: ", ";\n  > div {\n    margin: ", "px;\n  }\n"])), function (p) {
  return p.background || 'inherit';
}, function (p) {
  return p.color || 'inherit';
}, theme_1.theme.spacing.standard);

exports["default"] = function (props) {
  return react_1["default"].createElement(HeroContainer, __assign({}, props), react_1["default"].createElement("div", null, props.title && react_1["default"].createElement(H_1.H1, null, props.title), props.subtitle && react_1["default"].createElement(H_1.H2, null, props.subtitle), props.copy && react_1["default"].createElement("p", null, props.copy)), react_1["default"].createElement("div", null, props.image && react_1["default"].createElement(Img_1.Img, __assign({}, props.image))));
};

var templateObject_1;